import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { ScreenType } from 'src/app/enums/ScreenType';
import { visitorSummary } from 'src/app/models/table/visitorTable';
import { ITimeslot } from 'src/app/models/timeslot';
import { Visitor } from 'src/app/models/visitor';
import { ICalendarState } from 'src/app/state-management/states/aumye-calendar.state';
import { IAumyeState } from 'src/app/state-management/states/aumye.state';

@Component({
  selector: 'app-calendar-details',
  templateUrl: './calendar-details.component.html',
  styleUrls: ['./calendar-details.component.scss'],
})
export class CalendarDetailsComponent implements OnInit {
  @Input() calDimensions: any;
  @Input() selectedDate: any;
  @Input() visitorData: Visitor[];
  @Input() chartData: visitorSummary;
  @Input() set screen(val: ScreenType) {
    this.screenInfo = val;
  }
  destroyed$: Subject<any> = new Subject<any>();
  calendarState$: Observable<ICalendarState>;
  timeSLOTS: any;
  displayedColumns: string[] = ['time', 'select'];
  dataSource: ITimeslot[];
  getheight: number;
  getChartData: visitorSummary;
  style: { height: string; width: string };
  screenInfo: ScreenType;

  constructor(private store: Store<IAumyeState>, private datePipe: DatePipe) {
    this.calendarState$ = this.store.select('aumyeCalendarState');
    this.calendarState$.pipe(takeUntil(this.destroyed$)).subscribe((data) => {
      this.timeSLOTS = data.timeSlots.list;
      this.dataSource = this.timeSLOTS;
    });
    setTimeout(() => {});
  }
  ngOnInit(): void {
    this.getDivHeight();
    this.selectedDate = this.selectedDate ? this.selectedDate : new Date();
  }
  getDivHeight() {
    if (this.calDimensions) {
      this.style = {
        height: this.calDimensions.height.valueOf() + 'px',
        width: this.calDimensions.width.valueOf() + 'px',
      };
    }
  }
  ScreenType = ScreenType;
}
